// extracted by mini-css-extract-plugin
export var addressFields = "_ig-0";
export var animationContainer = "_ig-1";
export var footer = "_ig-2";
export var lineItems = "_ig-3";
export var modalContent = "_ig-4";
export var orderName = "_ig-5";
export var strong = "_ig-6";
export var warning = "_ig-7";